<!--
  Статус доставки исходящего сообщения чата с раскрытием текста ошибки.
-->
<template>
  <span
    v-if="visible"
    class="chat-delivery-status"
  >
    <span
      v-if="status === 'pending'"
      class="chat-delivery-status__dot chat-delivery-status__dot_pending"
      title="Отправляется"
    />
    <AppIcon
      v-else-if="status === 'sent'"
      class="chat-delivery-status__check"
      name="check"
      :size="12"
      title="Отправлено"
    />
    <button
      v-else-if="status === 'failed'"
      class="chat-delivery-status__error"
      type="button"
      :title="errorText"
      :aria-expanded="errorOpen"
      aria-label="Ошибка отправки"
      @click.stop="$emit('toggle-error')"
    />
  </span>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "ChatDeliveryStatus",

  components: {
    AppIcon,
  },

  props: {
    errorOpen: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["toggle-error"],
};
</script>

<style scoped>
.chat-delivery-status {
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  height: 12px;
  justify-content: center;
  width: 12px;
}

.chat-delivery-status__dot {
  border-radius: 50%;
  display: inline-block;
  height: 7px;
  width: 7px;
}

.chat-delivery-status__dot_pending {
  background: #8a8a8a;
}

.chat-delivery-status__check {
  color: var(--color-green);
}

.chat-delivery-status__error {
  background: var(--color-danger);
  border: 0;
  border-radius: 50%;
  cursor: help;
  height: 8px;
  padding: 0;
  width: 8px;
}
</style>
